module.exports = __webpack_public_path__ + "static/media/siliconvalley.fce187ec.jpg";